import { GlobalAttribute } from 'types/common';

import {
  siteAttributeKeysSubset,
  updateSiteAttributes,
} from '../SitePreferencesHooks';
import {
  TextsPreferencesFormFieldValues,
  UseTextsPreferencesFormHooks,
} from './TextsPreferencesHooks';
import { DeepPartialSkipArrayKey, UnpackNestedValue } from 'react-hook-form';
import {
  SITE_ATTRIBUTE_TEXT_ALLOW_CANCEL,
  SITE_ATTRIBUTE_TEXT_ALLOW_CONFIRMATION,
  SITE_ATTRIBUTE_TEXT_ALLOW_REMINDER,
  SITE_ATTRIBUTE_TEXT_ALLOW_WAITING_LIST,
} from '../../../../configs/siteAndTrustAttributes';

const keys = siteAttributeKeysSubset([
  SITE_ATTRIBUTE_TEXT_ALLOW_CONFIRMATION,
  SITE_ATTRIBUTE_TEXT_ALLOW_CANCEL,
  SITE_ATTRIBUTE_TEXT_ALLOW_REMINDER,
  SITE_ATTRIBUTE_TEXT_ALLOW_WAITING_LIST,
]);

const restAttributes: GlobalAttribute[] = keys.map((key) => ({ key }));

export const useTextRulingFormHooks: UseTextsPreferencesFormHooks = () => {
  return {
    restAttributes,
    beforeSubmit: (updatedSite, formValues) => {
      return {
        ...updatedSite,
        attributes: updateSiteAttributes(
          updatedSite.attributes,
          formValues.attributes,
          keys,
          (_, siteValue, formValue) => {
            return formValue || siteValue;
          },
        ),
      };
    },
  };
};

export const useTextRulingFormKeysValues = ({
  watchedValues,
}: {
  watchedValues: UnpackNestedValue<
    DeepPartialSkipArrayKey<TextsPreferencesFormFieldValues>
  >;
}): { [key in typeof keys[number]]: boolean } => {
  const attributes = watchedValues.attributes;
  return keys.reduce((result, key) => {
    return {
      ...result,
      [key]: Boolean(
        (attributes?.find((atr) => atr.key === key)?.value_int || 0) !== 0,
      ),
    };
  }, {} as { [key in typeof keys[number]]: boolean });
};
